import { render } from "./UCSearch.vue?vue&type=template&id=47177c7a&scoped=true"
import script from "./UCSearch.vue?vue&type=script&lang=js"
export * from "./UCSearch.vue?vue&type=script&lang=js"

import "./UCSearch.vue?vue&type=style&index=0&id=47177c7a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47177c7a"]])

export default __exports__